import { render, staticRenderFns } from "./AccommodationReviewFilter.vue?vue&type=template&id=4d247d4d&scoped=true&"
import script from "./AccommodationReviewFilter.vue?vue&type=script&lang=js&"
export * from "./AccommodationReviewFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d247d4d",
  null
  
)

export default component.exports